import api from './api'

const membresiaService = {
  // Obtener todas las membresías
  getAllMembresias: async () => {
    try {
      const data = await api.get('/sorteos')
      return data
    } catch (error) {
      console.error('Error al obtener membresías:', error)
      return []
    }
  },

  // Obtener una membresía específica
  getMembresiaById: async (id) => {
    try {
      const data = await api.get(`/sorteos/${id}`)
      return data
    } catch (error) {
      console.error('Error al obtener membresía:', error)
      return null
    }
  },

  // Crear nueva membresía (solo admin)
  createMembresia: async (membresiaData) => {
    try {
      const data = await api.post('/sorteos', membresiaData)
      return data
    } catch (error) {
      console.error('Error al crear membresía:', error)
      throw error
    }
  },

  // Actualizar membresía (solo admin)
  updateMembresia: async (id, membresiaData) => {
    try {
      const data = await api.put(`/sorteos/${id}`, membresiaData)
      return data
    } catch (error) {
      console.error('Error al actualizar membresía:', error)
      throw error
    }
  },

  // Subir imagen para membresía
  uploadImage: async (imageFile) => {
    try {
      const formData = new FormData()
      formData.append('image', imageFile)
      
      // Usar la configuración base del API service
      const response = await fetch('/api/upload', {
        method: 'POST',
        body: formData
      })
      
      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'Error al subir imagen')
      }
      
      const data = await response.json()
      // Convertir la URL relativa a URL completa
      return {
        ...data,
        imageUrl: data.imageUrl
      }
    } catch (error) {
      console.error('Error al subir imagen:', error)
      throw error
    }
  },

  // Eliminar membresía (solo admin)
  deleteMembresia: async (id) => {
    try {
      const data = await api.delete(`/sorteos/${id}`)
      return data
    } catch (error) {
      console.error('Error al eliminar membresía:', error)
      throw error
    }
  },

  // Crear premio secundario individual
  createPremioSecundario: async (premioData) => {
    try {
      const data = await api.post('/sorteos/premios-secundarios', premioData)
      return data
    } catch (error) {
      console.error('Error al crear premio secundario:', error)
      throw error
    }
  }
}

// Mantener compatibilidad hacia atrás
const sorteoService = {
  getAllSorteos: membresiaService.getAllMembresias,
  getSorteoById: membresiaService.getMembresiaById,
  createSorteo: membresiaService.createMembresia,
  updateSorteo: membresiaService.updateMembresia,
  deleteSorteo: membresiaService.deleteMembresia,
  uploadImage: membresiaService.uploadImage,
  createPremioSecundario: membresiaService.createPremioSecundario
}

export { membresiaService }
export default sorteoService